export const HTML_DRAFT_MAX_CHARS = 200000;
export const HTML_DRAFT_INTERVAL_MS = 500;
export const HTML_DRAFT_CSP = "default-src 'none'; script-src 'none'; style-src 'unsafe-inline'; img-src data:; font-src data:; base-uri 'none'; form-action 'none'; frame-src 'none'; object-src 'none'";

export function htmlDraftSource(html) {
  if (typeof html !== 'string' || html.length > HTML_DRAFT_MAX_CHARS
    || !/^\uFEFF?\s*(?:<!doctype\s+html\b[^>]*>|<html(?:\s|>))/i.test(html)
    || !/<body(?:\s[^>]*)?>/i.test(html)) return '';
  return html.replace(/\n[ \t]*(?:`{1,2}|~{1,2})[ \t]*$/, '');
}
